import { userService } from './../../../Services/userService';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { renewPolicyModel } from '../../../Models/policyModel';
import { motorProposalService } from '../../../Services/motorProposalService';
import { RenewBindMdl } from '../../../Models/RenewBindMdl';
import { TPLProposal } from '../../../Models/TPLProposal';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';


@Component({
    selector: 'RenewalProposal',
    templateUrl: './RenewalProposal.html',
    styleUrls: ['./RenewalProposal.css']
})
export class RenewalProposal {

    public isShowLoading: boolean = false;
    public renewPolicyReq: renewPolicyModel = new renewPolicyModel();
    public bindObj: RenewBindMdl = new RenewBindMdl();
    public prObj: TPLProposal = new TPLProposal();
    public ReviewInfo: boolean = false;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private userinfo: userService) {

        if (sessionStorage.getItem("rp") === null) {
            this.BindInfo();
        }
        else {
            this.bindObj = this.proposalService.getRenewalBindObj();
            this.prObj = this.proposalService.getRenewalProposalObj();

        }
    }


    BindInfo() {

        this.isShowLoading = true;
        //this.renewPolicyReq = JSON.parse(sessionStorage.getItem("renewObj"));
        this.renewPolicyReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("renewObj")));

        if (this.renewPolicyReq.RegNo == undefined) {
            this.renewPolicyReq.RegNo = sessionStorage.getItem("RegNo");
        }
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.renewPolicyReq));

        this.isShowLoading = true;
        //this.http.post<RenewBindMdl>(this.url.baseURL + "/RenewPolicy/RenewBindService", this.renewPolicyReq, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/RenewPolicy/RenewBindService", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                //this.bindObj = result;

                //New Line Start
                this.objPayloadResponse = result;
                this.bindObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End

                this.prObj = this.bindObj.TplObj;

                
                // if (this.bindObj.TplObj.st.StatusCode == "F" && this.prObj.isEditProposal == true) {
                //     Swal(this.bindObj.TplObj.st.StatusDesc);
                //     this.router.navigate(['/NewDashboard/Policy']);
                // }
                // else {

                if (this.prObj.isEditProposal == false) {
                    this.prObj.Insured_Education = "5";
                    this.prObj.InsuredProfessin = "1";
                    this.prObj.insuredDriverObj.RoadConvictions = 74;
                    this.prObj.Vechile.Vehicle_Mileage = "2";
                    this.prObj.Vechile.MileagePerYear = "1"
                    this.prObj.insuredDriverObj.SaudiLicenceHeld = "0";
                    this.prObj.insuredDriverObj.OtherCountriesLicenceHeld = "341";
                    this.prObj.ChildrenUnder = "1";
                    this.prObj.insuredDriverObj.NumberOfYearsEachCountry = "1";
                    this.prObj.insuredDriverObj.DriverMedicalConditions = "7";
                    if (this.bindObj.CityMasterList.filter(t => t.CITYNAME == this.prObj.OfficeCity).length <= 0) {
                        this.prObj.OfficeCity = "0";
                    }
                }
                else {
                    if (this.bindObj.TplObj.st.StatusCode == "F") {
                        Swal(this.bindObj.TplObj.st.StatusDesc);
                        this.router.navigate(['/NewDashboard/Policy']);
                    }
                }

                this.proposalService.saveRenewalProposalObj(this.prObj);
                this.proposalService.saveRenewalBindObj(this.bindObj);
                this.proposalService.sendRenewProposal(this.prObj);
                this.proposalService.sendRenewBindInfo(this.bindObj);
                //}


            },
                (error) => {
                    this.isShowLoading = false;
                    this.userinfo.checkTokenStatus(error);
                });
    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalProposal/RenewalProposal.ts